module.exports = __webpack_public_path__ + "static/img/female.df033b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/female.png
// module id = Cvss
// module chunks = 1